import { createTheme } from 'flowbite-react';

export const crispyvoiceTheme = createTheme({
    sidebar: {
        item: {
            content: {
                base: 'whitespace-normal'
            }
        },
        root: {
            inner: 'rounded-none bg-white dark:bg-gray-800',
            base: 'border-gray-200 dark:border-gray-700'
        }
    },
    progress: {
        bar: 'leading-6'
    },
    table: {
        head: {
            cell: {
                base: 'dark:bg-gray-700 bg-gray-200'
            }
        },
        row: {
            striped: 'odd:bg-white even:bg-gray-200 odd:dark:bg-gray-800 even:dark:bg-gray-700'
        }
    },
    modal: {
        body: {
            base: 'text-gray-500 dark:text-gray-400'
        }
    },
    button: {
        base: 'rounded',
        color: {
            crispyblue:
                'dark:bg-crispyblue-800 dark:hover:bg-crispyblue-700 dark:focus:ring-crispyblue-300 text-white bg-crispyblue-600 hover:bg-crispyblue-700 focus:ring-crispyblue-300',
            crispybluedark:
                'dark:bg-crispybluedark-700 dark:hover:bg-crispybluedark-600 dark:focus:ring-crispyblue-800 text-white bg-crispybluedark-600 hover:bg-crispybluedark-700 focus:ring-crispyblue-800',
            crispyhighlight:
                'dark:text-crispybluedark-700 dark:bg-amber-300 dark:hover:bg-amber-400 dark:focus:ring-4 dark:focus:ring-amber-300/50 text-crispybluedark-700 bg-yellow-200 hover:bg-amber-200 focus:ring-4 focus:ring-amber-300/50',
            yellow: 'bg-yellow-300 text-black hover:bg-yellow-400 focus:ring-yellow-400'
        },
        outlineColor: {
            blue:
                'border border-blue-700 text-blue-700 hover:border-blue-800 hover:bg-blue-800 hover:text-white focus:ring-blue-300 dark:border-blue-500 dark:text-blue-500 dark:hover:border-blue-700 dark:hover:bg-blue-700 dark:hover:text-white dark:focus:ring-blue-800',
            crispyblue:
                'border border-crispyblue-800 text-crispyblue-800 hover:border-crispyblue-700 hover:bg-crispyblue-700 hover:text-white focus:ring-crispyblue-300 dark:border-crispyblue-500 dark:text-crispyblue-500 dark:hover:border-crispyblue-700 dark:hover:bg-crispyblue-700 dark:hover:text-white dark:focus:ring-crispyblue-800',
            crispyhighlight: ''
        }
    }
});
